import { useObservable } from "@rsm";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { useHasFF } from "hooks/useHasFF";
import { useMainNavigate } from "hooks/useMainNavigate";
import { useResultsModuleBLoC } from "modules/ResultsModule/ResultsModule.bloc";
import { ResultsModuleHelpers } from "modules/ResultsModule/ResultsModule.helpers";
import React, { useEffect } from "react";

export const ResultsLandingPage: React.FC<{}> = () => {
  const { project$, followUpQuestions$, segmentQuestion$, narratives$ } = useResultsModuleBLoC();
  const project = useObservable(project$);
  const followUpQuestions = useObservable(followUpQuestions$);
  const segmentQuestion = useObservable(segmentQuestion$);
  const narratives = useObservable(narratives$);
  const hasProjectNarrativesFF = useHasFF("ProjectNarratives");
  const navigate = useMainNavigate();

  useEffect(() => {
    if (!project) return;
    const navigateToResults = (route: string) => {
      navigate(ResultsModuleHelpers.internalResultsLink(project.id, route), { replace: true });
    };

    if (hasProjectNarrativesFF && narratives?.[0]) {
      navigateToResults(`narratives/${narratives[0].id}`);
      return;
    }

    const route = ResultsModuleHelpers.getChartsRoute(
      project.projectType,
      project.frameworkId,
      segmentQuestion?.id,
      followUpQuestions?.[0]
        ? { id: followUpQuestions[0].id, questionTypeId: followUpQuestions[0].question.questionTypeId }
        : null,
    );
    if (route) navigateToResults(route);
  }, [project, navigate, followUpQuestions, segmentQuestion, narratives, hasProjectNarrativesFF]);

  return <LoadingPage />;
};
